import styled from "@emotion/styled";
import { AddModificationButton } from "components/NewOrders/AddModification/AddModificationStyles.ts";

export const AddCqModificationButton = styled(AddModificationButton)({
	alignSelf: "flex-start"
});
